<h1 mat-dialog-title>Submit for Review</h1>
<div mat-dialog-content>
  <p>
    The application is ready to be submitted. 
  </p>
  <p>
    Would you like to submit the application?
  </p>
</div>
<div mat-dialog-actions style="margin-top: 9px !important; float: right !important;">
  <button mat-raised-button
    (click)="onClickNo()">
    NO
  </button>
  <button mat-raised-button
    color="accent"
    [disabled]="disableGrantSave"
    (click)="onClickYes()">
    YES
</button>
</div>